import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/addbt.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5063a1b4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "overlay"
};
var _hoisted_2 = {
  "class": "text"
};
var _hoisted_3 = {
  "class": "group"
};
var _hoisted_4 = {
  key: 0,
  "class": "feedbackInfo"
};
var _hoisted_5 = {
  "class": "title"
};
var _hoisted_6 = {
  "class": "card"
};
var _hoisted_7 = {
  key: 0,
  "class": "item"
};
var _hoisted_8 = {
  "class": "label"
};
var _hoisted_9 = {
  "class": "value"
};
var _hoisted_10 = {
  "class": "item"
};
var _hoisted_11 = {
  "class": "label"
};
var _hoisted_12 = {
  "class": "value",
  style: {
    "white-space": "pre-wrap"
  }
};
var _hoisted_13 = {
  key: 1,
  "class": "item"
};
var _hoisted_14 = {
  "class": "label"
};
var _hoisted_15 = {
  "class": "value"
};
var _hoisted_16 = ["src", "onClick"];
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "width": "690px",
      "height": "2px",
      "background": "#F6F6F6"
    }
  }, null, -1);
});
var _hoisted_18 = {
  "class": "item"
};
var _hoisted_19 = {
  "class": "label"
};
var _hoisted_20 = {
  "class": "value"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "width": "690px",
      "height": "2px",
      "background": "#F6F6F6"
    }
  }, null, -1);
});
var _hoisted_22 = {
  "class": "item"
};
var _hoisted_23 = {
  "class": "label"
};
var _hoisted_24 = {
  "class": "value"
};
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "width": "690px",
      "height": "2px",
      "background": "#F6F6F6"
    }
  }, null, -1);
});
var _hoisted_26 = {
  "class": "item"
};
var _hoisted_27 = {
  "class": "label"
};
var _hoisted_28 = {
  key: 1,
  "class": "feedbackInfo processInfo"
};
var _hoisted_29 = {
  "class": "titlebox"
};
var _hoisted_30 = {
  "class": "title"
};
var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_32 = {
  key: 0
};
var _hoisted_33 = {
  "class": "left-box"
};
var _hoisted_34 = ["src"];
var _hoisted_35 = {
  key: 0,
  "class": "line"
};
var _hoisted_36 = {
  "class": "right-box"
};
var _hoisted_37 = {
  "class": "listtitlebox"
};
var _hoisted_38 = {
  "class": "name"
};
var _hoisted_39 = {
  "class": "date"
};
var _hoisted_40 = {
  "class": "listcontent",
  style: {
    "white-space": "pre-wrap"
  }
};
var _hoisted_41 = {
  "class": "images"
};
var _hoisted_42 = ["src", "onClick"];
var _hoisted_43 = {
  key: 1,
  "class": "empty"
};
import Activity from '@/common/components/Activity.vue';
// import Header from '@/common/components/Header.vue';
import { ScreenScrollView } from '@/common/components/ScreenScroll';
import TransitionRouteView from '@/common/components/TransitionRouteView.vue';
import { useNavigation } from '@/common/util/navigation';
import { postApiFeedbackInfo, postApiFeedbackMark } from '@/service/api';
import { feedbackInfoAction } from '@/util/event';
import { showImagePreview } from 'vant';
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useRoute } from 'vue-router';
import default_avatar from '@/assets/default_avatar.png';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var _useNavigation = useNavigation(),
      toNext = _useNavigation.toNext;
    var info = ref(null);
    var showfeedbackTc = ref();
    var _window = window,
      nickname = _window.nickname,
      avatar = _window.avatar;
    // const [info] = useApiToState(() => postApiFeedbackInfo({
    //     id: route.params.id as unknown as number,
    //     appId: window.appId,
    //     openId: window.openid,
    // }));
    /**
     * 商户：MERCHANT_RESPONSE
     * 用户：USER_REPLY
     */
    //  const [info] = useApiToState(() => postApiFeedbackInfo({
    //    id: route.params.id as unknown as number,
    //    appId: window.appId,
    //    openId: '13ca2ac66c094ef198d96d4af3ee7618',
    //  }));
    var urls = computed(function () {
      var _info$value;
      var url = ((_info$value = info.value) === null || _info$value === void 0 || (_info$value = _info$value.feedbackInfo) === null || _info$value === void 0 ? void 0 : _info$value.url) || '';
      if (!url) return [];
      return url.split(',').map(function (url) {
        return decodeURIComponent(url);
      });
    });
    var loadInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return postApiFeedbackInfo({
                id: route.params.id,
                appId: window.appId,
                openId: window.openid
              });
            case 2:
              res = _context.sent;
              info.value = res;
              // showfeedbackTc.value = info.value.feedbackInfo.isClick === 0;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadInfo() {
        return _ref.apply(this, arguments);
      };
    }();
    var addReply = function addReply() {
      toNext("/feedback/".concat(route.params.id, "/submitquestion"));
    };
    var toNotWorkOut = function toNotWorkOut() {
      setCloseClick();
      toNext("/feedback/".concat(route.params.id, "/fail"));
    };
    var toWorkOut = function toWorkOut() {
      setCloseClick();
      toNext("/feedback/".concat(route.params.id, "/success"));
    };
    var clickclose = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setCloseClick();
              _context2.next = 3;
              return postApiFeedbackMark({
                id: route.params.id,
                openId: window.openid,
                mark: 0
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function clickclose() {
        return _ref2.apply(this, arguments);
      };
    }();
    var setCloseClick = function setCloseClick() {
      console.log(info, 'info');
      showfeedbackTc.value = false;
    };
    var getStatusColor = function getStatusColor(status) {
      switch (status) {
        case 0:
          return '#F3552E';
        case 1:
          return '#5DD5AC';
        case 2:
          return '#F7B064';
        default:
          return '#222';
        // 默认颜色
      }
    };
    var getStatusName = function getStatusName(status) {
      switch (status) {
        case 0:
          return t('Pending');
        case 1:
          return t('Processed');
        case 2:
          return t('Processing');
        default:
          return t('UnknownStatus');
      }
    };
    onBeforeMount(function () {
      loadInfo();
      feedbackInfoAction.on('close', setCloseClick);
      feedbackInfoAction.on('refresh', loadInfo);
    });
    function formatDate(dateStr) {
      return dateStr.replace(/-/g, '.');
    }
    onBeforeUnmount(function () {
      feedbackInfoAction.off('close', setCloseClick);
      feedbackInfoAction.off('refresh', loadInfo);
    });
    var startPreview = function startPreview(index, urls) {
      showImagePreview({
        images: urls,
        startPosition: index
      });
    };
    function splitUrls(urlStr) {
      if (typeof urlStr !== 'string' || !urlStr.trim()) return [];
      return urlStr.split(',').map(function (u) {
        return u.trim();
      });
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "FeedbackInfoView",
        fixed: true
      }, {
        overlay: _withCtx(function () {
          var _info$value$feedbackI;
          return [info.value && info.value.feedbackInfo && ((_info$value$feedbackI = info.value.feedbackInfo) === null || _info$value$feedbackI === void 0 ? void 0 : _info$value$feedbackI.processStatus) === 1 && showfeedbackTc.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
            "class": "close",
            onClick: clickclose
          }), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('HasYourFeedbackBeenResolved')), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            "class": "button",
            onClick: toNotWorkOut
          }, _toDisplayString(_unref(t)('NotResolved')), 1), _createElementVNode("div", {
            "class": "button",
            onClick: toWorkOut
          }, _toDisplayString(_unref(t)('Resolved')), 1)])])) : _createCommentVNode("", true), _createVNode(TransitionRouteView)];
        }),
        "default": _withCtx(function () {
          return [_createVNode(_unref(ScreenScrollView), null, {
            "default": _withCtx(function () {
              var _info$value$feedbackI2, _info$value$feedbackI3, _info$value$feedbackI4, _info$value$feedbackI5, _info$value$feedbackI6, _info$value$feedbackI7, _info$value$feedbackI8, _info$value$feedbackI9, _info$value$feedbackI10, _info$value$feedbackI11;
              return [info.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('FeedbackDetails')), 1), _createElementVNode("div", _hoisted_6, [(_info$value$feedbackI2 = info.value.feedbackInfo) !== null && _info$value$feedbackI2 !== void 0 && _info$value$feedbackI2.problemTypeName ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('FrequentlyAskedQuestions')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString((_info$value$feedbackI3 = info.value.feedbackInfo) === null || _info$value$feedbackI3 === void 0 ? void 0 : _info$value$feedbackI3.problemTypeName), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('feedbackDescRequired')), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(((_info$value$feedbackI4 = info.value.feedbackInfo) === null || _info$value$feedbackI4 === void 0 ? void 0 : _info$value$feedbackI4.content) || ''), 1)]), (_unref(urls) || []).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('IssueImage')), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(urls), function (url, i) {
                return _openBlock(), _createElementBlock("img", {
                  key: url,
                  src: url,
                  onClick: function onClick($event) {
                    return startPreview(i, _unref(urls));
                  }
                }, null, 8, _hoisted_16);
              }), 128))])])) : _createCommentVNode("", true), _hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('contactMethod')), 1), _createElementVNode("div", _hoisted_20, _toDisplayString(((_info$value$feedbackI5 = info.value.feedbackInfo) === null || _info$value$feedbackI5 === void 0 ? void 0 : _info$value$feedbackI5.contact) || '-'), 1)]), _hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('SubmissionTime')), 1), _createElementVNode("div", _hoisted_24, _toDisplayString((_info$value$feedbackI6 = info.value.feedbackInfo) === null || _info$value$feedbackI6 === void 0 ? void 0 : _info$value$feedbackI6.addTime), 1)]), _hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('ProcessingStatus')), 1), _createElementVNode("div", {
                "class": "value",
                style: _normalizeStyle({
                  color: getStatusColor((_info$value$feedbackI7 = (_info$value$feedbackI8 = info.value.feedbackInfo) === null || _info$value$feedbackI8 === void 0 ? void 0 : _info$value$feedbackI8.processStatus) !== null && _info$value$feedbackI7 !== void 0 ? _info$value$feedbackI7 : -1)
                })
              }, _toDisplayString(getStatusName((_info$value$feedbackI9 = (_info$value$feedbackI10 = info.value.feedbackInfo) === null || _info$value$feedbackI10 === void 0 ? void 0 : _info$value$feedbackI10.processStatus) !== null && _info$value$feedbackI9 !== void 0 ? _info$value$feedbackI9 : -1)), 5)])])])) : _createCommentVNode("", true), info.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('FeedbackResponse')), 1), ((_info$value$feedbackI11 = info.value.feedbackInfo) === null || _info$value$feedbackI11 === void 0 ? void 0 : _info$value$feedbackI11.processStatus) !== 1 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "class": "title-right",
                onClick: addReply
              }, [_hoisted_31, _createElementVNode("p", null, _toDisplayString(_unref(t)('appendReply')), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
                "class": _normalizeClass(["card", {
                  'block': info.value && info.value.processInfos && info.value.processInfos && !showfeedbackTc.value
                }])
              }, [info.value.processInfos.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.processInfos, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  "class": "content",
                  key: item.url
                }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("img", {
                  "class": "lefticon",
                  src: item.operateType === 'MERCHANT_RESPONSE' ? require('../assets/kf.png') : _unref(avatar) || _unref(default_avatar),
                  alt: ""
                }, null, 8, _hoisted_34), index !== info.value.processInfos.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_35)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, _toDisplayString(item.operateType === 'MERCHANT_RESPONSE' ? _unref(t)('CustomerSupport') : _unref(nickname)), 1), _createElementVNode("p", _hoisted_39, _toDisplayString(formatDate(item.operateDateStr)), 1)]), _createElementVNode("p", _hoisted_40, _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitUrls(item.url), function (url, i) {
                  return _openBlock(), _createElementBlock("img", {
                    key: url,
                    src: url,
                    onClick: function onClick($event) {
                      return startPreview(i, splitUrls(item.url));
                    }
                  }, null, 8, _hoisted_42);
                }), 128))])])]);
              }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(t)('NoResponseReceived')), 1))], 2)])) : _createCommentVNode("", true)];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
});